exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "#diagram3a3-4 .long-arr-part1_short{width:295px;transform:rotate(17deg);left:-18px}#diagram3a3-4 .long-arr-part2_short{left:-25px;top:-6.8px;transform:rotate(25deg)}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./client/app/components/diagrams/3/3a3/diagram4/diagram4.scss
// module id = 1152
// module chunks = 0